import { NameRendererPosition } from '@utils/nameRendererCreatePositions';

const getPositionsForRegex = (regex: RegExp, text: string): Array<NameRendererPosition> => {
  const matches = [...text.matchAll(regex)];

  return matches.map((match) => ({
    from: match.index,
    to: match.index + match[0].length,
    format: true,
  }));
};

export default getPositionsForRegex;
